import { get, isEmpty } from "lodash";
import { useState, useEffect } from "react";

const useToast = () => {
    const [toastStatus, setToastStatus] = useState({ success: "", error: "" });
    const [toastConfig, setToastConfig] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });
    const [toastMessage, setToastMessage] = useState("");
    const [toastState, setToastState] = useState(null);

    const handleClick = (newState) => {
        setToastConfig({ ...newState, open: true });
    };

    const handleClose = () => {
        setToastConfig({ ...toastConfig, open: false });
    };

    useEffect(() => {
        if (!isEmpty(get(toastStatus, "error"))) {
            handleClick({ vertical: 'top', horizontal: 'right' });
            setToastMessage(get(toastStatus, "error"));
            setToastState("error");
        }
        if (!isEmpty(get(toastStatus, "success"))) {
            handleClick({ vertical: 'top', horizontal: 'right' });
            setToastMessage(get(toastStatus, "success"));
            setToastState("success");
        }
    }, [toastStatus])

    return {
        toastConfig,
        toastState,
        toastMessage,
        setToastStatus,
        handleClose
    }
}

export default useToast;